import { Component, Input, OnInit, Output, EventEmitter, TemplateRef, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from 'src/app/services/auth.service';
import { ScreeningAdditionalData, ScreeningLight, ScreeningNote } from 'src/app/models/screeningInvite';
import { FilteringService } from 'src/app/services/filtering.service';
import { SearchPackageService } from 'src/app/services/search-package.service';
import { ToastrService } from 'ngx-toastr';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { ScreeningService } from '../../services/screening.service';
import { CustomResponseData, SearchRecord, SearchStatus, VendorIdentifierLookupResponse } from 'src/app/packages-module/models/searchPackage';
import * as _ from 'lodash';
import { FileDownloadService } from 'src/app/services/file-download.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ResidenceVerificationFormComponent } from 'src/app/shared-components-module/residence-verification-form/residence-verification-form.component';
import { EmploymentVerificationFormComponent } from 'src/app/shared-components-module/employment-verification-form/employment-verification-form.component';
import { CriminalRecordsManagerComponent } from '../criminal-records-manager/criminal-records-manager.component';
import { ExcludableRecordsDialogComponent } from '../excludable-records-dialog/excludable-records-dialog.component';
import { RiqAlertComponent } from 'src/app/shared-components-module/riq-alert/riq-alert.component';
import { tap } from 'rxjs/operators';
import { DeepCleaningLogModalComponent } from '../deep-cleaning-log-modal/deep-cleaning-log-modal.component';

@Component({
  selector: 'app-screening-searches-table',
  templateUrl: './screening-searches-table.component.html',
  styleUrls: ['./screening-searches-table.component.less']
})
export class ScreeningSearchesTableComponent implements OnInit {
  @Input() additionalData : ScreeningAdditionalData;
  @Input() locationId : number;
  @Output() public screeningViewUpdate: EventEmitter<any> = new EventEmitter();
  @Output() public noteAdded: EventEmitter<ScreeningNote> = new EventEmitter();
  modalRef : NgbModalRef;

  @ViewChild('vendorIdModalTpl') vendorIdModalTpl: TemplateRef<unknown>;
  vendorIdModalValue = '';
  
  public get screeningToEdit() : ScreeningLight {
    return this.screening.screenings[0];
  }


  public constructor(public auth : AuthService,
    public filtering : FilteringService,
    public searches : SearchPackageService, 
    public toast : ToastrService, 
    public appData : ApplicantDataService, 
    public screening : ScreeningService,
    private modalService: NgbModal,
    private fileDownload : FileDownloadService){}

  ngOnInit(): void {
    console.warn(this.additionalData);
  }

  updateSearchStatus(pkg : ScreeningAdditionalData, forceComplete : boolean) {
    if(forceComplete) pkg.searchStatus = 8;
    this.searches.updateSearchStatus(pkg.searchEntryId, pkg.searchStatus).subscribe((res : any) => {
      if(res.success) {
        this.toast.success('Search status updated!');
        //TODO : logging
      }
      else {
        this.toast.error('Search failed to update!', '', { disableTimeOut: true, closeButton: true });
        //TODO : logging
      }
    },
    error => {
      this.toast.error('Search failed to update!', '', { disableTimeOut: true, closeButton: true });
      //TODO : logging
    })
  }

  public launchExcludeRecordModal(pkg : ScreeningAdditionalData) {
    const modalRef = this.modalService.open(ExcludableRecordsDialogComponent, { windowClass : 'bigAssModal'});
    modalRef.componentInstance.name = 'ExcludableRecordsDialogComponent';
    modalRef.componentInstance.locationId = this.locationId;
    modalRef.componentInstance.pkg = pkg;
    modalRef.componentInstance._screening = this.screeningToEdit;

 
 }

 refetchEta(pkg: ScreeningAdditionalData) {
  this.searches.refetchWholesaleEta(pkg.searchEntryId).pipe(tap((_: string) => {
    this.toast.success(_,'');
  },
  err => {
    this.toast.error('Error refetching wholesale ETA. Please contact support.', '', { closeButton: true });
  },
  () => {

  })).subscribe();
 }

  getVendorIdentifier(pkg: ScreeningAdditionalData) {
    this.searches.getLatestVendorIdentifier(pkg.searchEntryId).subscribe({
      next: (res: VendorIdentifierLookupResponse) => {
        this.vendorIdModalValue = res.vendorIdentifier;
        this.modalService.open(this.vendorIdModalTpl, { centered: true, size: 'lg', scrollable: true });
        setTimeout(() => {
          const el = document.getElementById('vendor-identifier-modal-input') as HTMLInputElement | null;
          el?.focus();
          el?.select();
        }, 200);
      },
      error: (err: HttpErrorResponse) => {
        const msg = err.status === 404 ? 'No vendor ID found.' : "Couldn't load vendor ID.";
        this.toast.error(msg, '', { timeOut: 5000, closeButton: true });
      }
    });
  }

  copyVendorIdFromModal(): void {
    const el = document.getElementById('vendor-identifier-modal-input') as HTMLInputElement | null;
    if (!el) {
      return;
    }
    el.focus();
    el.select();
    el.setSelectionRange(0, el.value.length);
    const value = this.vendorIdModalValue;
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(value).then(
        () => this.toast.success('Copied to clipboard.', '', { timeOut: 2500 }),
        () => this.fallbackCopySelected(el)
      );
    } else {
      this.fallbackCopySelected(el);
    }
  }

  private fallbackCopySelected(el: HTMLInputElement): void {
    try {
      document.execCommand('copy');
      this.toast.success('Copied to clipboard.', '', { timeOut: 2500 });
    } catch {
      this.toast.warning(
        'Copy was blocked. Select the text above and press Ctrl+C (Cmd+C on Mac).',
        '',
        { timeOut: 6000, closeButton: true }
      );
    }
  }

  
 runCommonName(pkg : ScreeningAdditionalData) {
    this.searches.markCommonNameSearch(pkg.searchEntryId).pipe(tap((_: boolean)=>{
      if(_){
        //then rerun the search
        this.rerunSearches(pkg);
      }else{
        this.toast.error('Error running common name criminal search. please contact the devs', 'Common Name Error');
      }
    })).subscribe();
  }
  clearAnimation(pkg : ScreeningAdditionalData){
    
  }

  editSearch(pkg : ScreeningAdditionalData) {
    // this.appData.GetAddressRecordsForApplicant(pkg.screeningId);
    // this.appData.GetAliasNameRecordsForApplicant(pkg.screeningId);
    
    // this.showReportPart = "";
    let editState = 'None';
     
    this.launchExcludeRecordModal(pkg);
    
    this.screeningViewUpdate.emit({
      editState : editState,
      showReportPart : pkg.searchType
    })
  }
  
  

  downloadVendorData(dta : ScreeningAdditionalData){
    this.screening.DownloadRawVendorData(dta.responseSeedId).subscribe((res:Blob)=>{
      if(res) {
        let extension = res.type.substring(res.type.indexOf('/')+1);
        this.fileDownload.HandleFileDownload(res, res.type, `VendorResponse-${dta.searchType}.${extension}`);
      } else {
        this.toast.error('Error downloading vendor records!', '', { closeButton: true, disableTimeOut: true });
      }
    },
    error => {
      this.toast.error('Error downloading vendor records!', '', { closeButton: true, disableTimeOut: true })
    }
    );
  }
  
  rerunSearches(pkgIndex : ScreeningAdditionalData){
    this.screeningToEdit.warned = false;
    pkgIndex.rerunSearch = true;
    // this.logger.FireLog(new ScreeningLog(`Search Rerun for token: ${this.screeningToEdit.screeningToken} - package: ${this.screeningToEdit.additionalData[pkgIndex].packageName}`, this.screeningToEdit.screeningToken, this.clients.currentClient.id), LogParserType.Screening)
    this.screening.RerunSearch(pkgIndex.searchEntryId).subscribe(
      (scc: boolean) =>{
        this.toast.success('Search Rerun in progress.');
      },
      (err: any) =>{
        this.toast.error('Search Rerun failed.', 'Error', { closeButton:true, disableTimeOut:true });
      })
  }

  refilterSearch(pkgIndex : ScreeningAdditionalData){
    this.screening.RefilterSearch(pkgIndex.searchEntryId).subscribe(
      (scc: boolean) =>{
        this.toast.success('Search Refilterin progress.');
      },
      (err: any) =>{
        this.toast.error('Search Refilterin failed.', 'Error', { closeButton:true, disableTimeOut:true });
      })
  }

  searchProcessing: boolean = false;
  sendSearchForProcessing(pkg : ScreeningAdditionalData) {
    if(this.searchProcessing)
    {
      this.toast.warning('Your Previous Search needs a couple more seconds to run');
      return;
    }
    this.searchProcessing = true;
    this.toast.info('Preparing search to run!')
    // since its a manual search if they fire multiple in a row this results in a race condition and multiple order histories getting made. we need to give the ASE time to get out of queued so we can send them.. or just send one ASE and make them both manual
    // For now Im gonna give the Jobs 5 seconds to call the first one sent as not queued anymore
    this.searches.runManualSearch(pkg.searchEntryId).subscribe((res : boolean) => {

      setTimeout(() =>{
        if(res) {
          this.toast.success('Running search!');
        } else {
          this.toast.error(`${pkg.searchName} failed to run!`, '', { closeButton: true, disableTimeOut: true });
        }
        this.searchProcessing = false
      } ,10000);
    },
    error => {
      this.toast.error(`${pkg.searchName} failed to run!`, '', { closeButton: true, disableTimeOut: true });
    });
  }

  public addVerificationData(pkg : ScreeningAdditionalData, isResVer : boolean = true) {
    
    if(isResVer) {
      this.modalRef = this.modalService.open(ResidenceVerificationFormComponent, { centered: true, size: 'xl' })
      this.modalRef.componentInstance.name = 'ResidenceVerificationFormComponent';
    } else {
      this.modalRef = this.modalService.open(EmploymentVerificationFormComponent, { centered: true, size: 'xl', backdrop: 'static'})
      this.modalRef.componentInstance.name = 'EmploymentVerificationFormComponent';
      this.modalRef.componentInstance.groupId = this.screeningToEdit.groupId;
      this.modalRef.componentInstance.noteAdded = this.noteAdded;
    }

    // common stuff
    this.modalRef.componentInstance.ase = pkg;
    this.modalRef.componentInstance.screeningToEdit = this.screeningToEdit;
  }

  voidBilling(s : ScreeningAdditionalData){
    const modalRef = this.modalService.open(RiqAlertComponent, { centered: true, size: 'md' });
    modalRef.componentInstance.name = 'VoidBillingModal';
    modalRef.componentInstance.title = "Void billing?";
    modalRef.componentInstance.confirmButtonText = "Yes I'm sure";
    modalRef.componentInstance.cancelButtonText = "Cancel";
    modalRef.componentInstance.alertBody = `This action will require a dev to undo.`;
    modalRef.componentInstance.evnt.subscribe((ev:boolean)=>{
    this.screening.VoidScreeningBillingEntry(s.searchEntryId).subscribe(
      (scc: boolean) =>{
        modalRef.dismiss();
        s.searchState = 3;
        s.searchStatus = 8;
        this.toast.success('Screening Invoice Item Voided.');
      },
      (err: any) =>{
        this.toast.error('Screening Invoice Item Void.', 'Error', { closeButton:true, disableTimeOut:true });
      })
    })
  }

  openDeepCleaningModal(pkg: ScreeningAdditionalData) {
    if (!this.auth.UserInRole('DeepCleaner')) {
      this.toast.error('You are not authorized to log deep cleaning.');
      return;
    }

    const modalRef = this.modalService.open(DeepCleaningLogModalComponent, {
      centered: true,
      size: 'md',
      backdrop: 'static'
    });
    modalRef.componentInstance.searchEntryId = pkg.searchEntryId;
    modalRef.closed.subscribe((result: any) => {
      if (result?.saved) {
        this.toast.success('Deep cleaning log saved.');
      }
    });
  }
}
